import React from "react";
import { EmbeddedReportPage } from "components";

// Компонент дашборд CompetitorsParsing
const CompetitorsParsingPage = () => {
  return (
    <EmbeddedReportPage
      pageTitle="Парсинг конкурентів"
      iframeTitle="Парсинг конкурентів"
      endpointUrl="/reports/competitors-parsing/embed-url"
    />
  );
};

export default CompetitorsParsingPage;
